import React, {
  useEffect,
  useState,
  createContext,
  SetStateAction,
  Dispatch,
  useContext,
} from 'react';
import { useIntercom } from 'react-use-intercom';
import { listenToSidebarStateMessage } from './utils/chromeExtension/chromeExtension';
import useWindowMessageReceiver from './utils/hook/windowMessageReceiver';
import { SIDEBAR_DISABLED_DOMAIN, SIDEBAR_STATE } from './utils/enums';
import { logEventToggleSidebar, logEventToggleSidebar2 } from './utils/analytics/eventLogger';
import { AuthContext } from './App';
import UserAPI from './database/User/UserAPI';

interface Props {
  setHasSidebarOpened: Dispatch<SetStateAction<boolean>>;
  children: React.ReactNode;
}

export const SidebarStateContext = createContext<boolean>(false);

const ListenToSidebarMessageContainer = ({ setHasSidebarOpened, children }: Props) => {
  const { data: sidebarOpenState } = useWindowMessageReceiver<boolean>(false, SIDEBAR_STATE);
  const { data: disabledDomain } = useWindowMessageReceiver<string>('', SIDEBAR_DISABLED_DOMAIN);
  const [isSidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const { trackEvent } = useIntercom();
  const authState = useContext(AuthContext);

  useEffect(() => {
    listenToSidebarStateMessage(setSidebarOpen);
  }, []);

  useEffect(() => {
    // TODO this is for the transition between CE versions, should be cleanded up in the future
    // console.log(`%c[W] received sidebar state message: '${sidebarOpenState}'`, 'color: navy');
    setSidebarOpen(sidebarOpenState);

    if (sidebarOpenState) {
      setHasSidebarOpened(true);
    }
  }, [sidebarOpenState]);

  useEffect(() => {
    if (!disabledDomain) return;
    if (!disabledDomain?.length) return;
    if (disabledDomain.length === 0) return;
    UserAPI.Settings.addDisabledDomain(authState.userId, disabledDomain);
  }, [disabledDomain]);

  useEffect(() => {
    if (isSidebarOpen) {
      console.log('Logging is sidebar open');
      logEventToggleSidebar(authState.userId, trackEvent, true);
      logEventToggleSidebar2(authState.userId, trackEvent, true);
    }
  }, [isSidebarOpen]);

  return (
    <SidebarStateContext.Provider value={isSidebarOpen}>
      {children}
    </SidebarStateContext.Provider>
  );
};

export default ListenToSidebarMessageContainer;
